import React from 'react';
import { ctaLink, logoUrl } from '../data/mock';
import { Send } from 'lucide-react';

const ClosingSection = () => {
  const handleCTAClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Subscribe');
    }
  };

  return (
    <section className="bg-[#F8F8F8] py-[50px] px-[25px] md:py-[75px] md:px-[75px] lg:py-[100px] lg:px-[100px]">
      <div className="max-w-4xl mx-auto">
        {/* Main Headline - Dramatic */}
        <h2 className="text-5xl md:text-7xl lg:text-8xl font-black text-[#191919] text-center mb-10 tracking-tight leading-tight">
          Last Words.
        </h2>

        {/* The Lonely Journey - Big Dramatic Statement */}
        <div className="bg-[#191919] rounded-3xl p-6 md:p-10 lg:p-12 text-center mb-10">
          <p className="text-3xl md:text-5xl lg:text-6xl text-[#F8F8F8] font-black tracking-tight leading-tight">
            Trading adalah <span className="text-[#FF6699]">lonely journey.</span>
          </p>
        </div>

        {/* The Pain Points - Stacked Dramatically - Tighter spacing */}
        <div className="space-y-3 mb-10">
          <div className="text-center py-3 border-b border-[#191919]/10">
            <p className="text-xl md:text-2xl lg:text-3xl text-[#191919]/60 font-medium">
              Chart tak faham anda stressed.
            </p>
          </div>
          <div className="text-center py-3 border-b border-[#191919]/10">
            <p className="text-xl md:text-2xl lg:text-3xl text-[#191919]/60 font-medium">
              Market tak kisah anda ada commitment lain.
            </p>
          </div>
          <div className="text-center py-3">
            <p className="text-xl md:text-2xl lg:text-3xl text-[#191919]/60 font-medium">
              Candle tak tahu anda baru loss semalam.
            </p>
          </div>
        </div>

        {/* The Hope - Big Pink Statement */}
        <div className="text-center mb-12">
          <p className="text-3xl md:text-5xl lg:text-6xl text-[#FF6699] font-black tracking-tight leading-tight">
            Tapi anda tak perlu buat semua ni sorang.
          </p>
        </div>

        {/* Visual Break */}
        <div className="flex justify-center items-center gap-4 mb-12">
          <div className="w-16 h-1 bg-[#191919]/20" />
          <div className="w-4 h-4 bg-[#FF6699] rounded-full" />
          <div className="w-16 h-1 bg-[#191919]/20" />
        </div>

        {/* The Truth About Smart Desk - Tighter spacing */}
        <div className="text-center mb-8">
          <p className="text-xl md:text-2xl text-[#191919]/50 font-medium mb-4">
            Fira Smart Desk bukan "the answer."
          </p>
          <div className="bg-[#FF6699]/10 rounded-2xl p-5 md:p-8 inline-block">
            <p className="text-2xl md:text-4xl lg:text-5xl text-[#191919] font-black tracking-tight">
              Smart Desk adalah satu tool dalam toolkit anda.
            </p>
          </div>
        </div>

        {/* The Parallels - Tighter spacing */}
        <div className="grid md:grid-cols-3 gap-3 md:gap-4 mb-10">
          <div className="bg-[#191919]/5 rounded-2xl p-5 text-center">
            <p className="text-lg md:text-xl text-[#191919]/70 font-medium">
              Sama macam anda perlukan <span className="text-[#191919] font-bold">broker.</span>
            </p>
          </div>
          <div className="bg-[#191919]/5 rounded-2xl p-5 text-center">
            <p className="text-lg md:text-xl text-[#191919]/70 font-medium">
              Sama macam anda perlukan <span className="text-[#191919] font-bold">knowledge.</span>
            </p>
          </div>
          <div className="bg-[#191919]/5 rounded-2xl p-5 text-center">
            <p className="text-lg md:text-xl text-[#191919]/70 font-medium">
              Sama macam anda perlukan <span className="text-[#191919] font-bold">mental strength.</span>
            </p>
          </div>
        </div>

        {/* The Need */}
        <div className="text-center mb-12">
          <p className="text-2xl md:text-4xl text-[#191919] font-black">
            Anda juga perlukan <span className="text-[#33CCCC]">system yang betul.</span>
          </p>
        </div>

        {/* The Final Invitation - Tighter spacing */}
        <div className="text-center mb-10">
          <p className="text-xl md:text-2xl text-[#191919]/60 font-medium mb-4">
            Dan kalau anda rasa Smart Desk boleh jadi part of your system —
          </p>
          <p className="text-4xl md:text-6xl lg:text-7xl text-[#FF6699] font-black tracking-tight">
            Fira tunggu anda di Telegram.
          </p>
        </div>

        {/* Final CTA Box */}
        <div className="bg-[#191919] rounded-3xl p-6 md:p-10 lg:p-12 text-center">
          {/* Logo */}
          <div className="flex justify-center mb-4">
            <img 
              src={logoUrl} 
              alt="Fira Indicator" 
              className="h-10 md:h-12 w-auto object-contain brightness-0 invert"
            />
          </div>

          <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#F8F8F8] mb-3 tracking-tight">
            FIRA SMART DESK
          </h3>

          <p className="text-xl md:text-2xl text-[#F8F8F8]/70 font-medium mb-8">
            Bukan janji profit. Tapi janji effort yang lebih smart.
          </p>

          {/* CTA Button */}
          <a
            href={ctaLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleCTAClick}
            className="inline-flex items-center gap-3 bg-[#33CCCC] hover:bg-[#2ab8b8] text-[#191919] font-black text-lg md:text-xl px-10 md:px-12 py-4 md:py-5 rounded-full transition-all duration-300 transform hover:scale-105"
          >
            <Send className="w-5 h-5 md:w-6 md:h-6" />
            JOIN TELEGRAM SEKARANG
          </a>
        </div>
      </div>
    </section>
  );
};

export default ClosingSection;
